/* Låter användaren välja ett nytt bräde. */
import React from "react";
import Modal from 'react-bootstrap/Modal';
import { Container, Row, Col } from 'react-grid-system';
import Button from 'react-bootstrap/Button';

class NewBoard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
    };

    render() {

        const handleClose = () => this.setState({ show: false });
        const handleShow = () => this.setState({ show: true });

        return (
            <>
                <button
                    className='reload'
                    onClick={handleShow}>
                    Nytt bräde
                </button>
                <Modal show={this.state.show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Välj brädstorlek</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row>
                                <Col xs={6}>
                                    Dagens
                                </Col>
                                <Col xs={6}>
                                    Slumpad
                                </Col>
                            </Row>
                            {this.props.sizes.map((element, index) => {
                                return (
                                    <Row key={index} style={{ padding: "1px" }}>
                                        <Col xs={6}>
                                            <Button
                                                style={{ width: "100%" }}
                                                onClick={() => { this.props.parent.getNextBoard(element, false) }}
                                                key={'d' + element}>{element}'a</Button>
                                        </Col>
                                        <Col xs={6}>
                                            <Button
                                                style={{ width: "100%" }}
                                                onClick={() => { this.props.parent.getNextBoard(element, true) }}
                                                key={'r' + element}>{element}'a</Button>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        {
                            window.matchMedia('(display-mode: standalone)').matches ?
                                <></>
                                :
                                <a href="/">
                                    <Button>
                                        Tillbaka till Kjells hemsida
                                    </Button>
                                </a>
                        }
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

}

export default NewBoard;
